import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-separator-with-text',
  standalone: true,
  imports: [],
  templateUrl: './separator-with-text.component.html',
  styleUrl: './separator-with-text.component.css'
})
export class SeparatorWithTextComponent implements OnInit{
  @Input() text: string = 'OR';

  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    if(this.text === 'OR')
    {
      this.translocoService.selectTranslate('auth.or').subscribe((translation) => {
        this.text = translation;
      });
    }
  }
}
